<span>
  <label for="countryDropdown" class="block mb-1 text-color-secondary" [iosRequired]="isRequired">{{ 'LABEL.COUNTRY' | translate }}</label>
  <p-dropdown
    id="countryDropdown"
    [options]="countries | cacheValues: country.value?.countryId"
    [formControl]="country"
    class="ios-selector-large"
    styleClass="w-full"
    appendTo="body"
    placeholder="{{ 'LABEL.SELECT_COUNTRY' | translate }}"
    optionDisabled="disabled"
    [autoDisplayFirst]="false"
    [disabled]="isDisabled"
    (focus)="onTouched()"
  >
    <ng-template let-selectedCountry pTemplate="selectedItem">
      <div class="flex align-content-center">
        {{ 'DB.COUNTRIES.CODE.' + selectedCountry?.countryCode | translate }}
      </div>
    </ng-template>
    <ng-template let-country pTemplate="item">
      {{ 'DB.COUNTRIES.CODE.' + country?.countryCode | translate }}
    </ng-template>
  </p-dropdown>
</span>
